import { Typography } from '@mui/material'
import React from 'react'

const Point = ({ title, street, city, phone, hours }) => {
	return (
		<>
			<Typography color="white" component="h6" sx={{ fontSize: 18, fontWeight: 900, mb: 2 }}>
				{title}
			</Typography>
			<Typography color="white" component="p" sx={{ fontSize: 16, fontWeight: 400, mb: 0.5 }}>
				{street}
			</Typography>
			<Typography color="white" component="p" sx={{ fontSize: 16, fontWeight: 400, mb: 2 }}>
				{city}
			</Typography>
			<Typography color="secondary" component="p" sx={{ fontSize: 12, fontWeight: 700, mb: 1 }}>
				Téléphone
			</Typography>
			<Typography color="white" component="p" sx={{ fontSize: 16, fontWeight: 400, mb: 2 }}>
				{phone}
			</Typography>
			<Typography color="secondary" component="p" sx={{ fontSize: 12, fontWeight: 700, mb: 1 }}>
				Horaires
			</Typography>
			{hours && (
				<Typography color="white" component="p" sx={{ fontSize: 16, fontWeight: 400 }}>
					{hours.map((hour, index) => (
						<span key={index}>
							{hour}
							<br />
						</span>
					))}
				</Typography>
			)}
		</>
	)
}

export default Point
